import { Navigate, useRoutes } from "react-router-dom";

import { Login, App } from "./containers";

import {
  Dashboard,
  Users,
  Profile,
  FormBuilder,
  Forms,
} from "./containers/App/pages";
import EditForm from "./containers/App/pages/Forms/EditForm";
import Theaters, {
  TheaterSectionsGrid,
  MainTheaterPage,
} from "./containers/App/pages/Theater";
import Events, {
  CreateEvent,
  Main,
  ViewSession,
  Answers,
} from "./containers/App/pages/Events";

export default function Router() {
  return useRoutes([
    { path: "/", element: <Login /> },
    {
      path: "/app",
      element: <App />,
      children: [
        { path: "dashboard", element: <Dashboard /> },
        {
          path: "events",
          element: <Events />,
          children: [
            { path: "all", element: <Main /> },
            {
              path: "create-session",
              element: <CreateEvent />,
              children: [
                { path: ":id", element: <CreateEvent /> },
                { path: "editsession/:sessionid", element: <CreateEvent /> },
              ],
            },
            {
              path: "viewsession/:id",
              element: <ViewSession />,
            },
            { path: "answers", element: <Answers /> },
          ],
        },
        {
          path: "theater",
          element: <Theaters />,
          children: [
            { path: "all", element: <MainTheaterPage /> },
            { path: "sections/:theaterID", element: <TheaterSectionsGrid /> },
          ],
        },
        { path: "forms", element: <Forms /> },
        { path: "createform", element: <FormBuilder /> },
        { path: "edit-form/:formId", element: <EditForm /> },
        { path: "users", element: <Users /> },
        { path: "profile", element: <Profile /> },
      ],
    },

    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
